'use client'

export const OPEN_GLOBAL_NAV_COMMAND_EVENT = 'fastfold:open-global-nav-command'

export function requestOpenGlobalNavCommand() {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new Event(OPEN_GLOBAL_NAV_COMMAND_EVENT))
}
